import { useParams } from "react-router-dom";
import QuestionPreview from "./QuestionPreview/QuestionPreview";
import { useAppSelector } from "../../Redux/hooks";

const StudyFormPreview = () => {
  const { id: studyId, formId } = useParams();
  const languages = useAppSelector((state) => state.study.languages);
  return (
    <QuestionPreview
      studyId={studyId}
      formId={formId || ""}
      type="study"
      languages={languages}
    />
  );
};

export default StudyFormPreview;
